export default "__VITE_ASSET__CJSlURhq__ 480w, __VITE_ASSET__CwYmIoDG__ 768w, __VITE_ASSET__COe8RGZn__ 1200w, __VITE_ASSET__vSD$th$x__ 1920w";